<template>
    <v-container fluid>
        <v-toolbar>
            <v-toolbar-title>Listado de pacientes</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Escriba un nombre"
                single-line
            ></v-text-field>
        </v-toolbar>
        <v-expansion-panels>
            <v-expansion-panel v-for="(patient) in filteredPatients" :key="patient.Id">
                <v-expansion-panel-header>{{ patient.Name }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-chip class="ma-2" label>
                        <v-icon left>mdi-card-account-details-outline</v-icon>
                        {{ patient.Rut }}
                    </v-chip>
                    <v-chip class="ma-2" label>
                        <v-icon left>mdi-email</v-icon>
                        {{ patient.Email }}
                    </v-chip>
                    <v-chip class="ma-2" label v-if="patient.BirthDate">
                        <v-icon left>mdi-cake</v-icon>
                        {{ patient.BirthDate }}
                    </v-chip>
                    <v-chip class="ma-2" label :key="i" v-for="(phone, i) in patient.Phones">
                        <v-icon left>mdi-phone</v-icon>
                        {{ phone }}
                    </v-chip>
                    <template v-if="patient.Address">
                        <v-chip class="ma-2" label>
                            <v-icon left>mdi-map-marker</v-icon>
                            <template v-if="JSON.parse(patient.Address).street">
                                {{ JSON.parse(patient.Address).street }}
                            </template>
                            <template v-if="JSON.parse(patient.Address).number">
                                {{ JSON.parse(patient.Address).number }},
                            </template>
                            <template v-if="JSON.parse(patient.Address).commune">
                                {{ JSON.parse(patient.Address).commune }},
                            </template>
                            <template v-if="JSON.parse(patient.Address).city">
                                {{ JSON.parse(patient.Address).city }}
                            </template>
                        </v-chip>
                    </template>
                    <v-textarea
                        :id="patient.Id"
                        filled
                        label="Información adicional"
                        auto-grow
                        :value="patient.AdditionalInfo"
                        @blur="saveAdditionalInfo"
                    ></v-textarea>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-container>
</template>

<script>
export default {
    name: "patient-list",
    data: () => ({
        patients: [],
        showDetail: false,
        search: ''
    }),
    methods: {
        showPatientDetails(index) {
            //console.log(index);
            this.showDetail = true;
        },
        async saveAdditionalInfo(event) {
            //console.log(event.target.value);
            //console.log(event.target.id);
            let token = this.$store.getters.token;
            const response = await fetch(this.$store.getters.apiUrl + "/api/v1/patient/save-additional-info", {
                method: 'POST',
                headers: new Headers({'Authorization': "Bearer " + token}),
                body: JSON.stringify({
                    info: event.target.value,
                    id: event.target.id
                }),
            });

            const responseData = await response.json();
            if (response.ok) {
                //console.log('saved', responseData);
            }
        }
    },
    async created() {
        let token = this.$store.getters.token;
        const response = await fetch(this.$store.getters.apiUrl + "/api/v1/patient/full-list", {
            method: 'POST',
            headers: new Headers({'Authorization': "Bearer " + token}),
        });

        const responseData = await response.json();
        if (response.ok) {
            this.patients = responseData;
        }
    },
    computed: {
        filteredPatients() {
            return this.patients.filter(item => {
                return item.Name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
            });
        }
    }
}
</script>

<style scoped>

</style>
